import { useMemo } from "react";
import { useAppContext } from "../hooks/useAppContext";
import { updateFrequency } from "../services/frequency.service";
import useToast from "./useToast";

export default function useFrequencyToggle() {
  const {
    cart,
    frequency,
    setFrequency,
    loadingItems,
    isLoadingFrequency,
    setIsloadingFrequency,
  } = useAppContext();

  function onToggle(e) {
    setFrequency(e.target.value);
    if (isLoadingFrequency || !cart) return;
    return syncWithBackendFrequency(e.target.value);
  }

  function syncWithBackendFrequency(frequencyToUpdate) {
    if (isLoadingFrequency) return;
    const newFrequency = frequencyToUpdate === "once" ? "one-time" : "monthly";
    const notifyFrequencyUpdateError = useToast({
      type: "error",
      id: "frequency",
      actionText: "RETRY?",
      action: async () => await syncWithBackendFrequency(frequencyToUpdate),
      dismissable: true,
      message: `There was a problem changing your order to a ${newFrequency} gift.`,
    });

    setIsloadingFrequency(true);
    return updateFrequency(frequencyToUpdate)
      .then((res) => {
        setFrequency(frequencyToUpdate);
        return res;
      })
      .catch(() => {
        notifyFrequencyUpdateError();
        setFrequency(frequency);
      })
      .finally(() => {
        setIsloadingFrequency(false);
      });
    return true;
  }

  const frequencyState = useMemo(
    () => ({
      onceIsActive: frequency === "once" ? "is-active" : "is-inactive",
      monthlyIsActive: frequency === "once" ? "is-inactive" : "is-active",
    }),
    [frequency]
  );

  const isLoading = loadingItems.length && !isLoadingFrequency;

  return {
    ...frequencyState,
    frequency,
    onToggle,
    isLoading,
  };
}
